"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildClientApp = buildClientApp;

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _arc = require("@artsy/arc");

var _createRelaySSREnvironment = require("../Relay/createRelaySSREnvironment");

var _react = _interopRequireDefault(require("react"));

var _user = require("../../Utils/user");

var _Boot = require("./Boot");

var _createRouteConfig = require("./Utils/createRouteConfig");

var _historyMiddlewares = require("./Utils/historyMiddlewares");

var _RenderStatus = require("./Utils/RenderStatus");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function buildClientApp(config) {
  var user = (0, _user.getUser)(config.context && config.context.user);
  return (0, _arc.buildClientApp)(_objectSpread({}, config, {
    routes: (0, _createRouteConfig.createRouteConfig)(config.routes),
    getRelayEnvironment: function getRelayEnvironment() {
      var relayEnvironment = (0, _createRelaySSREnvironment.createRelaySSREnvironment)({
        cache: JSON.parse(window.__RELAY_BOOTSTRAP__ || "{}"),
        user: user
      });
      return relayEnvironment;
    },
    getFarceConfig: function getFarceConfig() {
      return {
        historyMiddlewares: _historyMiddlewares.historyMiddlewares
      };
    },
    render: {
      renderPending: _RenderStatus.RenderPending,
      renderReady: _RenderStatus.RenderReady,
      renderError: _RenderStatus.RenderError,
      renderWrapper: function renderWrapper(_ref) {
        var Router = _ref.Router,
            relayEnvironment = _ref.relayEnvironment,
            routes = _ref.routes;
        return _react.default.createElement(_Boot.Boot, {
          context: config.context,
          user: user,
          relayEnvironment: relayEnvironment,
          routes: routes
        }, _react.default.createElement(Router, null));
      }
    }
  }));
}
//# sourceMappingURL=buildClientApp.js.map